import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper"

// Services
import {
  SearchPageSetting,
  SavePageSetting,
  UpdatePageSetting,
} from "../../services/api/module/PageSetting.js"
import {
  UpdateContent,
  CreateContent,
  GetContentById,
  CreateSetting,
  UpdateSetting,
} from "./services/Services"
import Error401 from "components/Error401"
import { ESG4PlusCard3 } from "./component/Card3"
import { ESG4PlusCard4 } from "./component/Card4"
import { ESG4PlusCard5 } from "./component/Card5"
import { ESG4PlusCard2 } from "./component/Card2"
import { ESG4PlusCard1 } from "./component/Card1"
import { HighlightContent } from "./component/HighlightContent"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS

const _routeLink = `esg-4-plus`
const _pageName = `ESG In Action`
const _routePermission = `esg-4-plus:content-setting`

const ESG4PlusContentSettingTemplate = ({
  pageView = "create",
  componentKey = "",
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = 1
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    // contentPageName: Yup.string().required("Please Enter Site Name"),
    // slug: Yup.string().max(255).required("Please Enter Slug"),

    // contentSeoTitle: Yup.string(),
    // contentSeoKeyword: Yup.string().max(1024),
    // contentSeoDescription: Yup.string().max(1024),

    contentUpdateDate: Yup.string()
      .max(100)
      .required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),
    contentDetail: Yup.string().required(
      "Please Enter Please Enter Business deatil"
    ),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const defalutAttchData = {
    attachmentField: "highlightCards",
    attachmentName: "-",
    attachmentRawName: "-",
    attachmentType: "-",
    attachmentTitle: " ",
    attachmentAlt: " ",
    attachmentExtension: "0",
    attachmentSize: "0",
    attachmentStatus: "active",
  }
  const defalutAttchData2 = {
    attachmentField: "highlightCards2",
    attachmentName: "-",
    attachmentRawName: "-",
    attachmentType: "-",
    attachmentTitle: " ",
    attachmentAlt: " ",
    attachmentExtension: "0",
    attachmentSize: "0",
    attachmentStatus: "active",
  }
  const initialValues = {
    contentId: "",

    // Content
    // contentSitename: "",
    // slug: "",
    contentDetail: "",
    contentDetail2: "",
    bannerDesktop: {},
    bannerMobile: {},

    contentSeoTitle: "",
    contentSeoKeyword: "",
    contentSeoDescription: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",

    slug: "",
    contentPageName: "",
    highlightCards: [defalutAttchData],
    highlightCards2: [defalutAttchData2],
    highlightImages: [],
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
      let payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.contentPageName,
        contentDetail: values.contentDetail,
        contentDetail2: values.contentDetail2,
        tab1Title: values.tab1Title ? values.tab1Title : null,
        tab1Detail: values.tab1Detail ? values.tab1Detail : null,
        tab1Detail2: values.tab1Detail2 ? values.tab1Detail2 : null,
        tab1Detail3: values.tab1Detail3 ? values.tab1Detail3 : null,
        tab1Detail4: values.tab1Detail4 ? values.tab1Detail4 : null,
        tab1TitleSection1: values.tab1TitleSection1
          ? values.tab1TitleSection1
          : null,
        tab1TitleSection2: values.tab1TitleSection2
          ? values.tab1TitleSection2
          : null,
        tab1Card1Detail: values.tab1Card1Detail ? values.tab1Card1Detail : null,
        tab1Card2Detail: values.tab1Card2Detail ? values.tab1Card2Detail : null,
        tab1Card3Detail: values.tab1Card3Detail ? values.tab1Card3Detail : null,
        tab1LinkUrl: values.tab1LinkUrl ? values.tab1LinkUrl : null,

        tab2Title: values.tab2Title ? values.tab2Title : null,
        tab2Detail: values.tab2Detail ? values.tab2Detail : null,
        tab2Detail2: values.tab2Detail2 ? values.tab2Detail2 : null,
        tab2Detail3: values.tab2Detail3 ? values.tab2Detail3 : null,
        tab2Detail4: values.tab2Detail4 ? values.tab2Detail4 : null,
        tab2HighlightTitle: values.tab2HighlightTitle
          ? values.tab2HighlightTitle
          : null,
        tab2LinkUrl: values.tab2LinkUrl ? values.tab2LinkUrl : null,

        tab3Title: values.tab3Title ? values.tab3Title : null,
        tab3Detail: values.tab3Detail ? values.tab3Detail : null,
        tab3Detail2: values.tab3Detail2 ? values.tab3Detail2 : null,
        tab3Detail3: values.tab3Detail3 ? values.tab3Detail3 : null,
        tab3Detail4: values.tab3Detail4 ? values.tab3Detail4 : null,
        tab3Detail5: values.tab3Detail5 ? values.tab3Detail5 : null,
        tab3LinkUrl: values.tab3LinkUrl ? values.tab3LinkUrl : null,

        tab4Title: values.tab4Title ? values.tab4Title : null,
        tab4Detail: values.tab4Detail ? values.tab4Detail : null,
        tab4Detail2: values.tab4Detail2 ? values.tab4Detail2 : null,
        tab4Detail3: values.tab4Detail3 ? values.tab4Detail3 : null,
        tab4InfoDescription1: values.tab4InfoDescription1
          ? values.tab4InfoDescription1
          : null,
        tab4InfoDescription2: values.tab4InfoDescription2
          ? values.tab4InfoDescription2
          : null,
        tab4InfoDescription3: values.tab4InfoDescription3
          ? values.tab4InfoDescription3
          : null,

        tab5Title: values.tab5Title ? values.tab5Title : null,
        tab5Detail: values.tab5Detail ? values.tab5Detail : null,
        tab5Detail2: values.tab5Detail2 ? values.tab5Detail2 : null,

        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        contentAttachmentData: {},
      }

      payload["contentAttachmentData"] = {
        tab1_icon1: values.tab1_icon1 ? values.tab1_icon1 : null,
        tab1_icon2: values.tab1_icon2 ? values.tab1_icon2 : null,
        tab1_bg: values.tab1_bg ? values.tab1_bg : null,
        tab1_content_image: values.tab1_content_image
          ? values.tab1_content_image
          : null,
        tab1_section_image1: values.tab1_section_image1
          ? values.tab1_section_image1
          : null,
        tab1_section_image2: values.tab1_section_image2
          ? values.tab1_section_image2
          : null,
        tab1_card_image1: values.tab1_card_image1
          ? values.tab1_card_image1
          : null,
        tab1_card_image2: values.tab1_card_image2
          ? values.tab1_card_image2
          : null,
        tab1_card_image3: values.tab1_card_image3
          ? values.tab1_card_image3
          : null,

        tab2_icon1: values.tab2_icon1 ? values.tab2_icon1 : null,
        tab2_icon2: values.tab2_icon2 ? values.tab2_icon2 : null,
        tab2_bg: values.tab2_bg ? values.tab2_bg : null,
        tab2_section_image1: values.tab2_section_image1
          ? values.tab2_section_image1
          : null,
        tab2_section_image2: values.tab2_section_image2
          ? values.tab2_section_image2
          : null,
        tab2_card_image1: values.tab2_card_image1
          ? values.tab2_card_image1
          : null,
        tab2_card_image2: values.tab2_card_image2
          ? values.tab2_card_image2
          : null,
        tab2_card_image3: values.tab2_card_image3
          ? values.tab2_card_image3
          : null,
        tab2_card_image4: values.tab2_card_image4
          ? values.tab2_card_image4
          : null,

        tab3_icon1: values.tab3_icon1 ? values.tab3_icon1 : null,
        tab3_icon2: values.tab3_icon2 ? values.tab3_icon2 : null,
        tab3_bg: values.tab3_bg ? values.tab3_bg : null,
        tab3_card_image1: values.tab3_card_image1
          ? values.tab3_card_image1
          : null,
        tab3_card_image2: values.tab3_card_image2
          ? values.tab3_card_image2
          : null,
        tab3_card_image3: values.tab3_card_image3
          ? values.tab3_card_image3
          : null,
        tab3_card_image4: values.tab3_card_image4
          ? values.tab3_card_image4
          : null,

        tab4_icon1: values.tab4_icon1 ? values.tab4_icon1 : null,
        tab4_icon2: values.tab4_icon2 ? values.tab4_icon2 : null,
        tab4_bg: values.tab4_bg ? values.tab4_bg : null,
        tab4_info_image1: values.tab4_info_image1
          ? values.tab4_info_image1
          : null,
        tab4_info_image2: values.tab4_info_image2
          ? values.tab4_info_image2
          : null,
        tab4_info_image3: values.tab4_info_image3
          ? values.tab4_info_image3
          : null,
        tab4_detail3_image: values.tab4_detail3_image
          ? values.tab4_detail3_image
          : null,

        tab5_icon1: values.tab5_icon1 ? values.tab5_icon1 : null,
        tab5_icon2: values.tab5_icon2 ? values.tab5_icon2 : null,
        tab5_bg: values.tab5_bg ? values.tab5_bg : null,
        tab5_card_image1: values.tab5_card_image1
          ? values.tab5_card_image1
          : null,
        tab5_card_image2: values.tab5_card_image2
          ? values.tab5_card_image2
          : null,
        tab5_card_image3: values.tab5_card_image3
          ? values.tab5_card_image3
          : null,
      }
      if (values.highlightCards && values.highlightCards.length > 0) {
        payload.contentAttachmentData.highlight_cards = values.highlightCards
      }
      if (values.highlightImages && values.highlightImages.length > 0) {
        payload.contentAttachmentData.highlight_images = values.highlightImages
      }
      if (values.highlightCards2 && values.highlightCards2.length > 0) {
        payload.contentAttachmentData.highlight_cards2 = values.highlightCards2
      }
      if (values.highlightImages2 && values.highlightImages2.length > 0) {
        payload.contentAttachmentData.highlight_images2 =
          values.highlightImages2
      }
      payload["contentAttachmentData"] = Object.fromEntries(
        Object.entries(payload["contentAttachmentData"]).filter(
          ([_, value]) => value !== null
        )
      )

      const pageSettingRoute = {
        contentPageName: values.contentPageName,
        slug: values.slug.replace(/-+$/, ""),
        componentKey: componentKey,
        attachmentData: {},
        contentAttachmentData: {
          bannerDesktop: values.bannerDesktop,
          bannerMobile: values.bannerMobile,
        },
        contentSeoTitle: values.contentSeoTitle,
        contentSeoKeyword: values.contentSeoKeyword,
        contentSeoDescription: values.contentSeoDescription,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,
      }

      console.log("🚀 ~ onSave ~ pageSettingRoute:", pageSettingRoute)

      setWaitSendData(true)

      if (pageView === "update") {
        API.fetchUpdateContentPageSetting(payload, pageSettingRoute)
      } else {
        API.fetchCreateContent(payload, pageSettingRoute)
      }
    },
  })

  // const preFilInput = (resData = {}) => {
  //     // console.log("🚀 ~ preFilInput ~ resData:", resData)
  //     // resetForm(validation.values, initialValues)

  //     // ถ้าไม่หน่วงมันจะแย่งกันทำ
  //     // validation.setFieldValue("contentId", resData?.contentId ?? "")
  //     // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
  //     // validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
  //     // validation.setFieldValue("slug", resData?.slug ?? "")
  //     // validation.setFieldValue("bannerDesktop", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_desktop') ?? "")
  //     // validation.setFieldValue("bannerMobile", resData?.contentAttachmentList?.find((obj) => obj.attachmentField == 'banner_mobile') ?? "")
  //     // validation.setFieldValue("contentThumbnail", resData?.contentThumbnail ?? "")

  //     // validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
  //     // validation.setFieldValue("contentSeoKeyword", resData?.contentSeoKeyword ?? "")
  //     // validation.setFieldValue("contentSeoDescription", resData?.contentSeoDescription ?? "")
  //     // validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
  //     // validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")

  // }

  const preFilInputPage = (resData = {}) => {
    console.log("🚀 ~ preFilInputPage ~ resData:", resData)
    // resetForm(validation.values, initialValues)
    validation.setFieldValue("contentId", resData?.contentId ?? "")

    validation.setFieldValue("contentPageName", resData?.contentPageName ?? "")
    validation.setFieldValue("slug", resData?.slug ?? "")
    validation.setFieldValue(
      "bannerDesktop",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_desktop"
      ) ?? ""
    )
    validation.setFieldValue(
      "bannerMobile",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "banner_mobile"
      ) ?? ""
    )
    validation.setFieldValue("contentSeoTitle", resData?.contentSeoTitle ?? "")
    validation.setFieldValue(
      "contentSeoKeyword",
      resData?.contentSeoKeyword ?? ""
    )
    validation.setFieldValue(
      "contentSeoDescription",
      resData?.contentSeoDescription ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )
  }

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    // validation.setFieldValue("contentId", resData?.contentId ?? "")
    // validation.setFieldValue("contentSitename", resData?.contentSitename ?? "")
    // validation.setFieldValue("slug", resData?.slug ?? "")
    // validation.setFieldValue("contentHeadline", resData?.contentHeadline ?? "")
    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

    validation.setFieldValue("contentDetail2", resData?.contentDetail2 ?? "")
    validation.setFieldValue("tab1Title", resData?.tab1Title ?? "")
    validation.setFieldValue("tab1Detail", resData?.tab1Detail ?? "")
    validation.setFieldValue("tab1Detail2", resData?.tab1Detail2 ?? "")
    validation.setFieldValue("tab1Detail3", resData?.tab1Detail3 ?? "")
    validation.setFieldValue("tab1Detail4", resData?.tab1Detail4 ?? "")
    validation.setFieldValue(
      "tab1TitleSection1",
      resData?.tab1TitleSection1 ?? ""
    )
    validation.setFieldValue(
      "tab1TitleSection2",
      resData?.tab1TitleSection2 ?? ""
    )
    validation.setFieldValue("tab1Card1Detail", resData?.tab1Card1Detail ?? "")
    validation.setFieldValue("tab1Card2Detail", resData?.tab1Card2Detail ?? "")
    validation.setFieldValue("tab1Card3Detail", resData?.tab1Card3Detail ?? "")
    validation.setFieldValue("tab1LinkUrl", resData?.tab1LinkUrl ?? "")

    validation.setFieldValue("tab2Title", resData?.tab2Title ?? "")
    validation.setFieldValue("tab2Detail", resData?.tab2Detail ?? "")
    validation.setFieldValue("tab2Detail2", resData?.tab2Detail2 ?? "")
    validation.setFieldValue("tab2Detail3", resData?.tab2Detail3 ?? "")
    validation.setFieldValue("tab2Detail4", resData?.tab2Detail4 ?? "")
    validation.setFieldValue(
      "tab2HighlightTitle",
      resData?.tab2HighlightTitle ?? ""
    )
    validation.setFieldValue("tab2LinkUrl", resData?.tab2LinkUrl ?? "")

    validation.setFieldValue("tab3Title", resData?.tab3Title ?? "")
    validation.setFieldValue("tab3Detail", resData?.tab3Detail ?? "")
    validation.setFieldValue("tab3Detail2", resData?.tab3Detail2 ?? "")
    validation.setFieldValue("tab3Detail3", resData?.tab3Detail3 ?? "")
    validation.setFieldValue("tab3Detail4", resData?.tab3Detail4 ?? "")
    validation.setFieldValue("tab3Detail5", resData?.tab3Detail5 ?? "")
    validation.setFieldValue("tab3LinkUrl", resData?.tab3LinkUrl ?? "")

    validation.setFieldValue("tab4Title", resData?.tab4Title ?? "")
    validation.setFieldValue("tab4Detail", resData?.tab4Detail ?? "")
    validation.setFieldValue("tab4Detail2", resData?.tab4Detail2 ?? "")
    validation.setFieldValue("tab4Detail3", resData?.tab4Detail3 ?? "")
    validation.setFieldValue(
      "tab4InfoDescription1",
      resData?.tab4InfoDescription1 ?? ""
    )
    validation.setFieldValue(
      "tab4InfoDescription2",
      resData?.tab4InfoDescription2 ?? ""
    )
    validation.setFieldValue(
      "tab4InfoDescription3",
      resData?.tab4InfoDescription3 ?? ""
    )

    validation.setFieldValue(
      "tab1_icon1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_icon1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_icon2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_icon2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_bg",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_bg"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_content_image",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_content_image"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_section_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_section_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_section_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_section_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_card_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_card_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_card_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_card_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab1_card_image3",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab1_card_image3"
      ) ?? ""
    )

    validation.setFieldValue(
      "tab2_icon1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_icon1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_icon2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_icon2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_bg",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_bg"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_section_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_section_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_section_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_section_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_card_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_card_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_card_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_card_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_card_image3",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_card_image3"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab2_card_image4",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab2_card_image4"
      ) ?? ""
    )

    validation.setFieldValue(
      "tab3_icon1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_icon1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_icon2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_icon2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_bg",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_bg"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_card_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_card_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_card_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_card_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_card_image3",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_card_image3"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab3_card_image4",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab3_card_image4"
      ) ?? ""
    )

    validation.setFieldValue(
      "tab4_icon1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_icon1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_icon2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_icon2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_bg",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_bg"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_info_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_info_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_info_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_info_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_info_image3",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_info_image3"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab4_detail3_image",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab4_detail3_image"
      ) ?? ""
    )

    validation.setFieldValue(
      "tab5_icon1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_icon1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab5_icon2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_icon2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab5_bg",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_bg"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab5_card_image1",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_card_image1"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab5_card_image2",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_card_image2"
      ) ?? ""
    )
    validation.setFieldValue(
      "tab5_card_image3",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField === "tab5_card_image3"
      ) ?? ""
    )

    validation.setFieldValue("tab5Title", resData?.tab5Title ?? "")
    validation.setFieldValue("tab5Detail", resData?.tab5Detail ?? "")
    validation.setFieldValue("tab5Detail2", resData?.tab5Detail2 ?? "")

    const highlightCards = (resData?.contentAttachmentList ?? []).filter(
        f => f.attachmentField == "highlight_cards"
      ) ?? [defalutAttchData]
    const highlightCards2 = (resData?.contentAttachmentList ?? []).filter(
        f => f.attachmentField == "highlight_cards2"
      ) ?? [defalutAttchData2]
    
      const highlightImages = (resData?.contentAttachmentList ?? []).filter(
        f => f.attachmentField == "highlight_images"
      ) ?? [defalutAttchData]
      const highlightImages2 = (resData?.contentAttachmentList ?? []).filter(
        f => f.attachmentField == "highlight_images2"
      ) ?? [defalutAttchData2]

    validation.setFieldValue(
      "highlightCards",
      highlightCards
    )
    validation.setFieldValue(
      "highlightImages",
      highlightImages
    )

    validation.setFieldValue(
      "highlightCards2",
      highlightCards2
    )
    validation.setFieldValue(
      "highlightImages2",
     highlightImages2
    )

    // console.log('resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"', resData.attachmentList.find(obj => obj.attachmentField == "banner_desktop"))

    validation.setFieldValue(
      "organizationChartDesktop",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "organization_chart_desktop"
      ) ?? ""
    )
    validation.setFieldValue(
      "organizationChartMobile",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "organization_chart_mobile"
      ) ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )

    // validation.setFieldValue("contentPageName", resData?.pageSettingRoute?.contentPageName ?? "")
    // validation.setFieldValue("slug", resData?.pageSettingRoute?.slug ?? "")
  }

  const API = {
    fetchGetContentPageSetting: async componentKey => {
      try {
        const response = await SearchPageSetting(componentKey, {
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInputPage(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },

    fetchGetContentById: async payload => {
      try {
        const response = await GetContentById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        qMainId = 0
        // mAlert.info({
        //     title: "Alert",
        //     subTitle: "Something went wrong 001",
        //     content: "",
        //     onClose: () => {
        //         //  alert("onClose")
        //     },
        // })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContent: async (payload, pageSettingRoute) => {
      try {
        const response = await CreateContent({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/${qLang}/edit`)
              window.location.reload()
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContentPageSetting: async (payload, pageSettingRoute) => {
      try {
        const response = await UpdateContent({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.error && resData.status == 406) {
          response = await CreateContent({ data: payload, lang: qLang })
          resData = response.data
          if (resData.status == 201) {
            mAlert.info({
              title: "Alert",
              subTitle: "Update Data Success",
              content: "",
              onClose: () => {
                // navigate(`/${_routeLink}/page/${qLang}/edit`)
                //window.location.reload()
              },
            })
          }
        } else if (resData.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              // navigate(`/${_routeLink}/page/${qLang}/edit`)
              //window.location.reload()
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)

      API.fetchGetContentById(payload)
      // API.fetchGetContentPageSetting(componentKey)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  const mapValues = (list = []) =>
    list.map(item => {
      const newObj = {
        attachmentId: item.attachmentId,
        sequence: item.sequence,
      }
      return newObj
    })

  if (
    !checkScope(`${_routePermission}:create`) ||
    !checkScope(`${_routePermission}:update`) ||
    !checkScope(`${_routePermission}:view`)
  ) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} Page Settings`}
            breadcrumbItems={[
              { title: "Page Settings", link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Card style={{ backgroundColor: "#ffe6fcff" }}>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-cube-alt"></i> Information Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentDetail"
                                  className="col-md-12 col-form-label"
                                >
                                  Detail
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentDetail"
                                    placeholder=""
                                    name="contentDetail"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentDetail",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentDetail}
                                    invalid={
                                      validation.touched.contentDetail &&
                                      validation.errors.contentDetail
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentDetail &&
                                    validation.errors.contentDetail && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentDetail}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentDetail2"
                                  className="col-md-12 col-form-label"
                                >
                                  Detail2
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <MyEditor
                                    id="contentDetail2"
                                    placeholder=""
                                    name="contentDetail2"
                                    onChange={(e, editor) => {
                                      const data = editor.getData()
                                      validation.setFieldValue(
                                        "contentDetail2",
                                        data
                                      )
                                      console.log({ e, editor, data })
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentDetail2}
                                    invalid={
                                      validation.touched.contentDetail2 &&
                                      validation.errors.contentDetail2
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentDetail2 &&
                                    validation.errors.contentDetail2 && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentDetail2}
                                      </FormFeedback>
                                    )}
                                </div>
                                <hr />
                              </Col>

                              {/* <Col className="col-6 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageVideoMap"
                                    upload="ImageVideo"
                                    prefixName="banner-desktop"
                                    label="Banner Desktop"
                                    required={true}
                                    description="description"
                                    widthSize={2160}
                                    heightSize={990}
                                    value={validation.values.bannerDesktop}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerDesktop",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerDesktop",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.bannerDesktop &&
                                    validation.errors.bannerDesktop && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.bannerDesktop}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col>
                              <Col className="col-6 mb-3">
                                <div className="col-md-12">
                                  <PopupAttachment
                                    typeDetail="single"
                                    typeUpload="ImageVideoMap"
                                    upload="ImageVideo"
                                    prefixName="banner-mobile"
                                    label="Banner Mobile"
                                    required={true}
                                    description="description"
                                    widthSize={540}
                                    heightSize={780}
                                    value={validation.values.bannerMobile}
                                    onChange={(value = {}, index) => {
                                      console.log("🚀 onChange ~ value:", value)
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerMobile",
                                        value
                                      )
                                    }}
                                    onRemove={index => {
                                      console.log("🚀 onChange ~ index:", index)
                                      validation.setFieldValue(
                                        "bannerMobile",
                                        {}
                                      )
                                    }}
                                  />
                                  {validation.touched.bannerMobile &&
                                    validation.errors.bannerMobile && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.bannerMobile}
                                      </div>
                                    )}
                                </div>
                                <hr />
                              </Col> */}
                            </Row>
                          </CardBody>
                        </Card>

                        {/* มุ่ง Net Zero */}
                        <ESG4PlusCard1
                          validation={validation}
                          pageView={pageView}
                        />

                        {/* Go Green */}
                        <ESG4PlusCard2
                          validation={validation}
                          pageView={pageView}
                        />

                        {/* Lean เหลื่อมล้ำ */}
                        <ESG4PlusCard3
                          validation={validation}
                          pageView={pageView}
                        />

                        {/* ย้ำร่วมมือ */}
                        {/* <ESG4PlusCard4 validation={validation} pageView={pageView} /> */}

                        {/* เป็นธรรม โปร่งใส */}
                        {/* <ESG4PlusCard5 validation={validation} pageView={pageView} /> */}
                      </Col>
                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                              validation.values
                                                .contentUpdateDate,
                                              "YYYY-MM-DD"
                                            ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${
                                      validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                        ? "input-err"
                                        : ""
                                    }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              {/* <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/business-feature-story/${qLang}`)}>Back</Button>
                                                                </Col> */}
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                      <Col className="col-12">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-trending-up"></i> SEO Box
                          </h5>
                          <CardBody>
                            <Row className="">
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Title
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoTitle"
                                    className="form-control"
                                    type="text"
                                    placeholder="Page Title"
                                    name="contentSeoTitle"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentSeoTitle}
                                    invalid={
                                      validation.touched.contentSeoTitle &&
                                      validation.errors.contentSeoTitle
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoTitle &&
                                    validation.errors.contentSeoTitle && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentSeoTitle}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Description
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoDescription"
                                    className="form-control"
                                    type="text"
                                    placeholder="SEO Description"
                                    name="contentSeoDescription"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.contentSeoDescription
                                    }
                                    invalid={
                                      validation.touched
                                        .contentSeoDescription &&
                                      validation.errors.contentSeoDescription
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoDescription &&
                                    validation.errors.contentSeoDescription && (
                                      <FormFeedback type="invalid">
                                        {
                                          validation.errors
                                            .contentSeoDescription
                                        }
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Meta Keywords
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <Input
                                    id="contentSeoKeyword"
                                    className="form-control"
                                    type="text"
                                    placeholder="SEO Keywords"
                                    name="contentSeoKeyword"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentSeoKeyword}
                                    invalid={
                                      validation.touched.contentSeoKeyword &&
                                      validation.errors.contentSeoKeyword
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                  />
                                  {validation.touched.contentSeoKeyword &&
                                    validation.errors.contentSeoKeyword && (
                                      <FormFeedback type="invalid">
                                        {validation.errors.contentSeoKeyword}
                                      </FormFeedback>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ESG4PlusContentSettingTemplate)
